import { render, staticRenderFns } from "./ywb-ys.vue?vue&type=template&id=a2ee3fa6"
import script from "./ywb-ys.vue?vue&type=script&lang=js"
export * from "./ywb-ys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports